export default "__VITE_ASSET__efedb7d5__"